import { definePreference } from "src/shared/config/preferenceDefinitions"

export const developerToolsPreference = definePreference<boolean>()({
  key: "developer-tools-enabled",
  kind: "boolean",
  defaultValue: false,
})
